import React from 'react';

import { useLanguage } from '../LanguageContext';
import { renderFormattedText } from '../utils/textFormatter';

export default function OasiaParkingDetails() {
  const { t } = useLanguage();
  const tBlock = (k) => t(`schedule.oasia_parking.${k}`);

  const options = [
    {
      nameKey: 'opt1_name',
      walkKey: 'opt1_walk',
      noteKey: 'opt1_note',
      badge: 'recommended',
    },
    {
      nameKey: 'opt2_name',
      walkKey: 'opt2_walk',
      noteKey: 'opt2_note',
    },
  ];

  return (
    <div className="w-full my-4 space-y-3">
      {/* Table */}
      <div className="rounded-xl border border-divider shadow-sm bg-white/70 backdrop-blur-sm overflow-x-auto">
        <table className="w-full text-left border-collapse table-fixed">
          <thead>
            <tr className="bg-blush-bg/80 border-b border-divider text-content-c1-sb uppercase tracking-wider">
              <th scope="col" className="w-1/2 py-3 px-4">
                {tBlock('headers.location')}
              </th>
              <th scope="col" className="w-1/2 py-3 px-4">
                {tBlock('headers.walk_notes')}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-divider/50">
            {options.map((opt, idx) => (
              <tr
                key={idx}
                className={`transition-colors hover:bg-offwhite-bg/80`}
              >
                <td className="py-3.5 px-4 align-top">
                  <div className="flex flex-col gap-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="font-bold text-content-c1 text-base">
                        {tBlock(opt.nameKey)}
                      </span>
                      {opt.badge === 'recommended' && (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-content-c1 bg-amber-100 text-amber-800 border border-amber-200 text-sm">
                          ✦ {tBlock('badges.recommended')}
                        </span>
                      )}
                    </div>
                  </div>
                </td>
                <td className="py-3.5 px-4 align-top text-content-c1">
                  <div className="flex flex-col gap-1 text-base">
                    <div className="flex items-start gap-1.5">
                      <span>📍</span>
                      <div>
                        <span className="text-content-c1-sb">{t('schedule.est_walk_prefix')}: </span>
                        <span>{tBlock(opt.walkKey)}</span>
                      </div>
                    </div>
                    <div className="flex items-start gap-1.5">
                      <span>ℹ️</span>
                      <div>
                        <span className="text-content-c1-sb">{t('schedule.note_prefix')}: </span>
                        <span>{renderFormattedText(tBlock(opt.noteKey))}</span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Disclaimer */}
      <p className="text-base text-content-c1 italic pt-1">
        *{tBlock('disclaimer')}
      </p>
    </div>
  );
}
